import { render } from "./ChatbotView.vue?vue&type=template&id=0683b7d5"
import script from "./ChatbotView.vue?vue&type=script&lang=js"
export * from "./ChatbotView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__